type FEPObject = { articleType: string | null } & Record<string, unknown>;

const getFEPObject = (): FEPObject =>
  typeof window.FEP_object !== 'undefined' && window.FEP_object[0] ? window.FEP_object[0] : {};

export const getArticleType = (): string | null => {
  const object = getFEPObject();
  return object.articleType;
};
